import type { PaginationMeta } from "./common";

export type HandbookStatus = "draft" | "published";

/** /about/* 슬롯. 비어있으면 일반 doc. 한 슬롯엔 doc 1개 (백엔드 sparse unique). */
export type HandbookAboutSlot = "intro" | "korean-occult";

export const ABOUT_SLOT_OPTIONS: { value: HandbookAboutSlot; label: string }[] =
  [
    { value: "intro", label: "intro (자료집 소개)" },
    { value: "korean-occult", label: "한국 오컬트란 무엇인가" },
  ];

export interface HandbookFootnote {
  /** 어드민이 발급한 안정 id. 본문 `<sup data-footnote-id>` 마커와 매칭. */
  id: string;
  /** 각주 HTML — 본문과 같은 백엔드 sanitize allowlist 통과. */
  content: string;
}

export interface HandbookListItem {
  _id: string;
  slug: string;
  title: string;
  subtitle: string | null;
  thumbnailUrl: string | null;
  parentIds: string[];
  relatedIds: string[];
  aboutSlot: HandbookAboutSlot | null;
  excerpt: string | null;
  tags: string[];
  status: HandbookStatus;
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface HandbookDetail extends HandbookListItem {
  content: string;
  footnotes: HandbookFootnote[];
  createdBy: string | null;
  updatedBy: string | null;
}

export interface HandbooksResult {
  items: HandbookListItem[];
  meta: PaginationMeta;
}

export interface HandbookFilters {
  status?: HandbookStatus;
  tag?: string;
  /** 제목 검색어 */
  search?: string;
}

export interface CreateHandbookInput {
  slug: string;
  title: string;
  content: string;
  excerpt?: string;
  tags?: string[];
  publishNow?: boolean;
  subtitle?: string | null;
  thumbnailUrl?: string | null;
  parentIds?: string[];
  relatedIds?: string[];
  aboutSlot?: HandbookAboutSlot | null;
  footnotes?: HandbookFootnote[];
}

export interface UpdateHandbookInput {
  handbookId: string;
  /** 변경 가능. undefined = 무변경. 백엔드가 중복 시 ConflictException. */
  slug?: string;
  title?: string;
  content?: string;
  excerpt?: string;
  tags?: string[];
  subtitle?: string | null;
  thumbnailUrl?: string | null;
  parentIds?: string[];
  relatedIds?: string[];
  aboutSlot?: HandbookAboutSlot | null;
  footnotes?: HandbookFootnote[];
}

export interface HandbookMutationResult {
  success: boolean;
  message?: string;
  handbook?: HandbookDetail;
}
